export default "__VITE_ASSET__DOZBJm89__"